import styled, { css } from 'styled-components'

export const Header = styled.div`
  svg {
    width: 16px;
    color: #4c4c4c;
    padding: 8px;
    border-radius: 8px;
    background-color: #f0f0f0;
    margin-right: 16px;
    float: left;
    cursor: pointer;
    &:hover {
      color: #213f68;
      background-color: #9ecffa40;
    }
  }
  span {
    font-size: 20px;
    font-weight: 700;
    color: #213f68;
  }
`

export const StepsContainer = styled.div`
  padding: 24px 0;
  .ant-steps-item-active > div > div > div {
    font-weight: 700;
  }
  .ant-steps-item-wait > div > div > span,
  .ant-steps-item-wait > div > div > div {
    color: #262626 !important;
  }
  svg {
    background-color: #e7f3fe;
    border-radius: 32px;
    padding: 5px;
    width: 14px;
    height: 14px;
  }
`

export const Title = styled.div`
  color: #213f68;
  font-size: 16px;
  font-weight: 700;
`

export const Subtitle = styled.div<{ $required?: boolean }>`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
  ${(props) =>
    props.$required &&
    css`
      &::after {
        content: ' *';
        color: #f5222d;
      }
    `}
`

export const Buttons = styled.div`
  height: 64px;
  padding-top: 24px;
  button {
    height: 40px;
    border-radius: 8px;
    padding: 0 12px;
    color: #2684ff !important;
    background-color: #e7f3fe !important;
    border: none;
    font-weight: 700;
    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
  > div {
    float: left;
  }
  > div + div {
    float: right;
  }
  > div + div > div > button {
    margin-left: 8px;
    color: white !important;
    background-color: #2684ff !important;
  }
  > div + div + div > div > button {
    color: #4c4c4c !important;
    background-color: #f0f0f0 !important;
  }
`
